import PersonForm from "@/components/person/PersonForm";
import PersonResetPassword from "@/components/person/PersonResetPassword";
import Basket from "@/components/order/Orders";
import PersonSearchPage from "@/components/person/PeopleSearchPage.vue";
export default [
  {
    path: "/people",
    component: {
      render(h) {
        return h("router-view");
      }
    },
    meta: { breadcrumbI18n: "navigation:breadcrumbs.people.title" },
    children: [
      {
        path: "",
        component: PersonSearchPage,
        name: "PeopleSearchPage",
        meta: {
          keepAlive: true,
          anchor: "#jumpMobile"
        }
      },
      {
        path: "new",
        name: "PersonCreationPage",
        component: PersonForm,
        meta: {
          breadcrumb: "New",
          requireAuthorize: true,
          anchor: "#jumpBreadcrumb"
        }
      },
      {
        path: "duplicates",
        name: "DuplicatePeople",
        component: () => import("@/components/person/DuplicatePeople"),
        meta: {
          breadcrumb: "Duplicates",
          requireAuthorize: true,
          anchor: "#jumpBreadcrumb"
        }
      },

      {
        path: "duplicate_management",
        component: () => import("@/components/duplicates/DuplicateMerge.vue"),
        name: "PersonDuplicateMerge",
        props: function (route) {
          return {
            mode: "people",
            personId: route.query.personId,
            personIdTwo: route.query.personIdTwo
          };
        },
        meta: {
          anchor: "#jumpBreadcrumb"
        }
      },

      {
        path: ":personId",
        name: "PersonRoot",
        component: {
          render(h) {
            return h("router-view");
          }
        },
        props: true,
        redirect: { name: "PersonProfilePage" },
        meta: { breadcrumb: { breadcrumbName: "personName" } },
        children: [
          {
            path: "",
            name: "PersonProfilePage",
            component: () => import("@/components/person/PersonProfilePage"),
            props: true,
            meta: { breadcrumb: "Profile", anchor: "#jumpBreadcrumb" }
          },
          {
            path: "edit",
            name: "PersonEditPage",
            component: PersonForm,
            props: true,
            meta: {
              breadcrumb: "Edit",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "payables",
            name: "Payables",
            props: true,
            component: Basket,
            meta: {
              breadcrumb: "Shopping basket",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },

          {
            path: "dashboard",
            name: "PersonDashboardPage",
            props: true,
            component: () =>
              import("@/components/dashboards/PersonDashboard.vue"),
            meta: {
              requireAuthorize: true,
              breadcrumbI18n: "navigation:breadcrumbs.personDashboard.title",
              anchor: "#jumpBreadcrumb"
            }
          },

          {
            path: "reset_password",
            name: "PersonResetPassword",
            component: PersonResetPassword,
            props: true,
            meta: {
              breadcrumb: "Set new password",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "profession_application",
            name: "PersonApplicationProfessionForm",
            component: () =>
              import(
                /* webpackChunkName: "master-backoffice" */ "@/components/admin/Officials/PersonApplicationProfessionForm.vue"
              ),
            props: true,
            meta: {
              breadcrumb: "New profession application",
              requireAuthorize: true,
              anchor: "#jumpMobile"
            }
          },
          {
            path: "profession_application/:applicationId/edit",
            name: "PersonApplicationProfessionFormEdit",
            component: () =>
              import(
                /* webpackChunkName: "master-backoffice" */ "@/components/admin/Officials/PersonApplicationProfessionForm.vue"
              ),
            props: true,
            meta: {
              breadcrumb: "Edit profession application",
              requireAuthorize: true,
              anchor: "#jumpMobile"
            }
          },
          {
            path: "profession_application/:applicationId/view",
            name: "PersonApplicationProfessionFormView",
            component: () =>
              import(
                /* webpackChunkName: "master-backoffice" */ "@/components/admin/Officials/PersonApplicationProfessionForm.vue"
              ),
            props: function (route) {
              route.params.onlyViewable = true;
              return route.params;
            },
            meta: {
              breadcrumb: "View profession application",
              requireAuthorize: true,
              anchor: "#jumpMobile"
            }
          }
        ]
      }
    ]
  }
];
